import { tronAddressToEthAddress } from '../../../../../../../utils/tronAddressToEthAddress';

export const createSignPayloadMessage = ({
  rowData,
  rawTx,
  isTron,
}: {
  rowData: any;
  rawTx: any;
  isTron: boolean;
}) => {
  // const chainType = rowData?.chain_type;
  // const isTron = Number(chainType) === 3;

  const fromAddress = rawTx?.from;
  const toAddress = rawTx?.to;
  const value = rawTx?.value;
  const data = rawTx?.data;
  const nonce = rawTx?.nonce;
  const batchId = rawTx?.batch_id;

  const byteData = data ? data : '0x';

  const payload = {
    batchId: batchId,
    nonce: nonce,
    from: isTron ? tronAddressToEthAddress(fromAddress || '') : fromAddress,
    to: isTron ? tronAddressToEthAddress(toAddress || '') : toAddress,
    value: value,
    data: isTron ? `0x${data}` : byteData,
  };

  return payload;
};
